import uniqueAsync from "@/components/forms/validations/uniqueAsync"
import requiredWith from "@/components/forms/validations/requiredWith"
import tenantRoleLimits from "@/components/forms/validations/tenantRoleLimits"
import companySitesComplete from "@/components/forms/validations/companySitesComplete"

// each module exports { rules: {...}, messages: {...} } - merge them separately so modules don't overwrite each other
const validationModules = [uniqueAsync, requiredWith, tenantRoleLimits, companySitesComplete]

export default {
  rules: Object.assign({}, ...validationModules.map((mod) => mod.rules)),
  messages: Object.assign({}, ...validationModules.map((mod) => mod.messages)),
}
